import React from "react";
import DayForm from "./DayForm";
import * as DayService from "../../Services/DayService";

const StartDay = () => {
  const submitStart = (formData) => DayService.startDay(formData);
  return <DayForm mode="start" onSubmit={submitStart} />;
};

export default StartDay;
